import * as tslib_1 from "tslib";
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, Renderer2, ViewChild, } from '@angular/core';
import { TerrificOnInit } from '../../../helpers/angular-terrific-on-init/terrific-on-init';
import { PublicEvents, onPublicEvent, triggerPublicEvent } from '@project/shared/utils/events/js/events';
var FILTER_MARKETSWITCH_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return FilterMarketSwitchComponent; }),
    multi: true,
};
/**
 * Note: The disabled state for the whole filter is not yet implemented.
 */
var FilterMarketSwitchComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FilterMarketSwitchComponent, _super);
    /**
     * FilterMarketSwitch constructor
     * @param elementRef
     * @type ElementRef
     * @description Injects a reference to the rendered element in DOM
     *
     */
    function FilterMarketSwitchComponent(elementRef, renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.filterChanges = new EventEmitter();
        /**
         * ControlValueAccessor Interface and mutator:
         * => placeholder for the onChange callback which is later provided by the Control Value Accessor
         */
        _this.onChangeCallback = function (_) { };
        /**
         * ControlValueAccessor Interface and mutator:
         * => placeholder for the onTouched callback which is later provided by the Control Value Accessor
         */
        _this.onTouchedCallback = function (_) { };
        return _this;
    }
    FilterMarketSwitchComponent.prototype.ngOnInit = function () {
        if (this.filter) {
            if (this.filter.name && !this.label) {
                this.label = this.filter.name;
            }
            if (this.filter.tooltip) {
                this.tooltip = this.filter.tooltip;
            }
        }
        _super.prototype.ngOnInit.call(this);
    };
    FilterMarketSwitchComponent.prototype.onTerrificBootstrap = function () {
        var _this = this;
        var inputSelectElement = this.inputSelect.nativeElement;
        this.renderer.setAttribute(inputSelectElement, 'data-t-name', 'InputSelect');
        this.terrific.startNode(inputSelectElement);
        onPublicEvent(PublicEvents.uxChange, inputSelectElement, function (event) {
            if (event.target !== inputSelectElement) {
                return;
            }
            var terrificModule = _this.getTerrificModule();
            if (terrificModule) {
                /**
                 * get the selected item
                 */
                var selectedItemName_1 = terrificModule.getValue();
                _this.innerValue = _this.filter.values.find(function (item) {
                    return item.name === selectedItemName_1;
                });
                // fire terrific syncLabel event
                triggerPublicEvent(PublicEvents.uxSyncLabel, terrificModule, event['target']);
                // filter change event
                _this.filterChanges.emit(_this.innerValue.id);
            }
        });
        onPublicEvent(PublicEvents.uxHide, inputSelectElement, function () {
            _this.filter.isOpen = false;
        });
        onPublicEvent(PublicEvents.uxShow, inputSelectElement, function () {
            _this.filter.isOpen = true;
        });
    };
    FilterMarketSwitchComponent.prototype.ngOnDestroy = function () {
        this.terrific.stopNode(this.inputSelect.nativeElement);
    };
    FilterMarketSwitchComponent.prototype.onHostClick = function (event) {
        if (this.filter.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
            this.filter.isOpen = false;
        }
    };
    /**
     * Get the Terrific Module by node
     */
    FilterMarketSwitchComponent.prototype.getTerrificModule = function () {
        if (this.terrific) {
            return this.terrific.getModuleByDomNode(this.inputSelect.nativeElement);
        }
        return null;
    };
    FilterMarketSwitchComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    FilterMarketSwitchComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    FilterMarketSwitchComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    FilterMarketSwitchComponent.prototype.trackMarketOption = function (index, item) {
        return item.id;
    };
    FilterMarketSwitchComponent.decorators = [
        { type: Component, args: [{
                    // FIXME: https://angular.io/styleguide#style-06-03
                    host: { '(document:click)': 'onHostClick($event)' },
                    selector: 'cov-filter-market-switch',
                    providers: [FILTER_MARKETSWITCH_VALUE_ACCESSOR],
                    // @todo consider moving m-filter-market-switch__tooltip to tooltip
                    template: "<div class=\"m-filter-market-switch\"\r\n\t [ngClass]=\"{'m-filter-market-switch--is-disabled': disabled}\"\r\n\t data-t-name=\"FilterMarketSwitch\">\r\n\t<div class=\"m-filter-market-switch__dropdown\">\r\n\t\t<label *ngIf=\"label\" class=\"a-label\" [innerHtml]=\"label\"></label>\r\n\t\t<select\r\n\t\t\t#inputSelect\r\n\t\t\tdata-search=\"true\"\r\n\t\t\tdata-fullwidth=\"true\"\r\n\t\t\tdata-cookie=\"cov_market\"\r\n\t\t\tdata-custom-dropdown-class=\"select2-dropdown--add-space select2-dropdown--with-icon\"\r\n\t\t\tclass=\"a-input-select a-input-select--market\">\r\n\t\t\t<option\r\n\t\t\t\t[ngValue]=\"item.id\"\r\n\t\t\t\t[innerHtml]=\"item.name\"\r\n\t\t\t\t[selected]=\"item.checked\"\r\n\t\t\t\t*ngFor=\"let item of filter.values; trackBy: trackMarketOption;\">\r\n\t\t\t</option>\r\n\t\t</select>\r\n\t</div>\r\n\t<div class=\"m-filter-market-switch__tooltip\"></div>\r\n\t<cov-tooltip [covTooltip]=\"tooltip\"></cov-tooltip>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    FilterMarketSwitchComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    FilterMarketSwitchComponent.propDecorators = {
        tooltip: [{ type: Input }],
        filter: [{ type: Input }],
        inputSelect: [{ type: ViewChild, args: ['inputSelect',] }],
        filterChanges: [{ type: Output }]
    };
    return FilterMarketSwitchComponent;
}(TerrificOnInit));
export { FilterMarketSwitchComponent };
//# sourceMappingURL=filter-market-switch.component.js.map